export default function parsePx(str) {
  return parseFloat(str.replace('px', ''));
};



/** WEBPACK FOOTER **
 ** ./src/functions/parsePx.js
 **/